// DI   TGP-026
// Countdown timer with Dallas, TX (Central Time) timezone reference

document.addEventListener('DOMContentLoaded', () => {
  const countdownBars = document.querySelectorAll('.countdown-bar');
  
  countdownBars.forEach((bar) => {
    const endDateStr = bar.getAttribute('data-countdown-end');
    const showZeros = bar.getAttribute('data-show-zeros') === 'true';
    
    if (!endDateStr) return;
    
    // Parse the end date and treat it as Central Time (Dallas, TX)
    // Convert format "YYYY-MM-DD HH:MM:SS" to ISO format for iOS compatibility
    // Replace space with 'T' and append timezone offset
    const isoDateStr = endDateStr.replace(' ', 'T') + '-06:00'; // CST is UTC-6
    const endDate = new Date(isoDateStr);
    
    const timer = bar.querySelector('.countdown-bar__timer');
    if (!timer) return;
    
    const daysEl = timer.querySelector('[data-unit="days"]');
    const hoursEl = timer.querySelector('[data-unit="hours"]');
    const minutesEl = timer.querySelector('[data-unit="minutes"]');
    const secondsEl = timer.querySelector('[data-unit="seconds"]');
    
    function updateCountdown() {
      const now = new Date();
      const difference = endDate - now;
      
      // Check if countdown has ended
      if (difference <= 0) {
        if (showZeros) {
          // Show all zeros
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
        } else {
          // Hide the entire section
          bar.classList.add('countdown-bar--hidden');
        }
        return;
      }
      
      // Calculate time units
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);
      
      // Update display with zero padding
      daysEl.textContent = String(days).padStart(2, '0');
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
    }
    
    // Update immediately
    updateCountdown();
    
    // Update every second
    setInterval(updateCountdown, 1000);
  });
});
